export const config = {
  title: "Do It Right Lawn Care & Weed Control | Odessa/Midland, TX",
  meta: {
    description:
      "Do It Right Lawn Care & Weed Control provides professional lawn maintenance, weed control, and landscaping services in Odessa and Midland, TX. Keeping your yard healthy, green, and weed-free.",
    keywords: [
      "Do It Right Lawn Care",
      "Lawn Care Odessa TX",
      "Weed Control Midland TX",
      "Landscaping Odessa",
      "Lawn Maintenance Texas",
      "Tree Trimming Odessa",
      "Irrigation Repair Midland"
    ],
    author: "Do It Right Lawn Care & Weed Control",
    canonicalUrl: "https://www.doitrightlawncareservices.com/",
  },
  sections: {
    header: {
      businessName: "Do It Right Lawn Care & Weed Control",
    },
    sectionB: {
      heroTitle: "Keeping Your Yard Looking Its Best",
      heroSubtitle: "Professional Lawn Care & Weed Control in Odessa/Midland, TX",
      learnAboutText: "Call for a Free Estimate",
      phoneNumber: "4328899666",
      phoneLabel: "432-889-9666",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2215629297/photo/spraying-the-grass-in-the-garden-with-a-garden-sprayer-against-ticks-and-mosquitoes-fighting.jpg?s=612x612&w=0&k=20&c=2qgNZwLvyaNa6teaUqiIWc_at5Ga1AIVK9050rR2oaU=",
      cardData: [
        {
          title: "Lawn Maintenance & Mowing",
          description:
            "Professional mowing and lawn maintenance services to keep your yard healthy, green, and perfectly manicured.",
        },
        {
          title: "Weed Control & Fertilization",
          description:
            "Comprehensive weed control and fertilization programs to maintain a lush, weed-free lawn year-round.",
        },
        {
          title: "Landscaping & Cleanup",
          description:
            "Complete landscaping services including seasonal cleanup, mulching, rock work, and yard beautification.",
        },
      ],
      description:
        "At Do It Right Lawn Care & Weed Control, we take pride in keeping your yard looking its best — healthy, green, and weed-free. We make sure the job gets done right, every time.",
    },
    sectionC: {
      servicesTitle: "Our Lawn Care Services",
      servicesDescription:
        "We provide top-quality, reliable lawn care and landscaping services that keep your property beautiful and your outdoor space thriving.",
      cards: [
        {
          title: "Mowing & Lawn Maintenance",
          description:
            "Regular mowing, edging, and lawn maintenance to keep your property looking pristine throughout the season.",
          imageSrc: "https://media.istockphoto.com/id/2162445313/photo/green-grass-cutting-with-lawn-mower-in-home-garden.jpg?s=612x612&w=0&k=20&c=2EFBNzWAEmFweSCDizuawWonChWNw5vwyNev3Ne_a10=",
          imageAlt: "Lawn Mowing Services",
        },
        {
          title: "Weed Control & Fertilization",
          description:
            "Professional weed control treatments and fertilization programs designed for Texas lawns and climate conditions.",
          imageSrc: "https://media.istockphoto.com/id/1208798141/photo/weedicide-spray-on-the-weeds-in-the-garden-spraying-pesticide-with-portable-sprayer-to.jpg?s=612x612&w=0&k=20&c=qdord6z6b6zFv2dTU1eo_eXdrMq987NnWbnWbUWo7VA=",
          imageAlt: "Weed Control Services",
        },
        {
          title: "Tree Trimming & Pruning",
          description:
            "Expert tree trimming and pruning services to maintain healthy trees and enhance your property's appearance.",
          imageSrc: "https://media.istockphoto.com/id/172624371/photo/tree-pruning-service-with-wood-chipper-and-workers-on-street.jpg?s=612x612&w=0&k=20&c=zcV0tYaEj6aShsb3PNMqd7l_rp_HF9-2Cieh3U5gdUk=",
          imageAlt: "Tree Trimming Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Seeding & Irrigation Repair",
        "Seasonal Clean Up",
        "Mulching Services",
        "Rock & Dirt Work",
        "Commercial Properties",
      ],
    },
    sectionD: {
      aboutTitle: "About Do It Right Lawn Care & Weed Control",
      aboutImage: {
        src: "https://static.wixstatic.com/media/5cd02a_54cb6853e5be4e75b3363c116373587b~mv2.jpg/v1/fill/w_289,h_289,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/20F009CF-FCC9-42F6-AB5A-9EC7A1C6F5A9_L0_001-10_13_2025%2C%204_15_11%20PM.jpg",
        alt: "Do It Right Lawn Care Team",
      },
      aboutText: [
        "Our mission at Do It Right Lawn Care & Weed Control is to provide excellence in every service we provide. We deliver top-quality, reliable lawn care and landscaping services that keep your property beautiful and your outdoor space thriving.",
        "Our vision is to be Odessa's most trusted name in lawn maintenance — known for our honesty, hard work, and dedication to doing it right the first time. We serve both residential and commercial properties throughout the Odessa and Midland areas.",
      ],
    },
    sectionE: {
      profileImage: "https://static.wixstatic.com/media/5cd02a_54cb6853e5be4e75b3363c116373587b~mv2.jpg/v1/fill/w_289,h_289,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/20F009CF-FCC9-42F6-AB5A-9EC7A1C6F5A9_L0_001-10_13_2025%2C%204_15_11%20PM.jpg",
      profileAlt: "Do It Right Lawn Care & Weed Control",
      businessName: "Do It Right Lawn Care & Weed Control",
      contact: {
        phone: "4328899666",
        phoneLabel: "432-889-9666",
        email: "clo@doitrightlawncareservices.com",
        website: "https://www.doitrightlawncareservices.com/",
        address: "Odessa/Midland, TX",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/DoItRightLawnCare",
        instagram: "https://www.instagram.com/doitrightlawncare",
      },
    },
    sectionF: {
      address: "Odessa/Midland, TX",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3350.123456789!2d-102.3677778!3d31.8456890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86490123456789ab%3A0x123456789abcdef0!2sOdessa%2C%20TX!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;
